import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { QcsToggleButton } from '../common/basic/QcsToggleButton';
import { useTranslation } from 'react-i18next';
import { FC, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { QcsButton } from '../common/basic/QcsButton';
import { GridFilterItemContainer } from '../common/grid/GridFilterStyles';
import { visitationListActions, VisitationListFilter } from '../../store/entities/visitationList';
import { FormContainer } from '../common/form/FormContainer';
import { QcsCheckbox } from '../common/basic/QcsCheckbox';
import { QcsFormControlLabel } from '../common/basic/QcsFormControlLabel';
import { StyledQcsPopover } from '../common/grid/GridFilterItem';
import { QcsAutocompleteWithoutFormik } from '../common/form/QcsAutocompleteWithoutFormik';
import { getLangNameObj } from '../../utils/format';
import { FetchState } from '../../store/fetchState';
import { getOptionsSupplier, selectOptionsSupplier, selectOptionsSupplierState } from '../../store/entities/optionsSupplier';
import { CancelToken } from 'axios';
import { InvitationType } from '@api/models/enums/InvitationType';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

interface Props {
  query: VisitationListFilter;
}

export const VisitationFilterSupplier: FC<Props> = ({ query }) => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const dispatch = useAppDispatch();
  const optionsSupplier = useAppSelector(selectOptionsSupplier);
  const optionsSupplierState = useAppSelector(selectOptionsSupplierState);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsSupplier(search, cancelToken));
  };

  const handleChangeOneTimeOnly = () => {
    dispatch(
      visitationListActions.updateFilter(
        !!query.invitationTypes
          ? {
              invitationTypes: undefined,
            }
          : {
              invitationTypes: [InvitationType.OneTime, InvitationType.OneTimeEntry],
              supplier: undefined,
            },
      ),
    );
  };

  const handleChange = (value?: ReferenceDto | ReferenceDto[] | null) => {
    dispatch(
      visitationListActions.updateFilter({
        supplier: (value as ReferenceDto) ?? undefined,
      }),
    );
  };

  const handleClear = () => {
    dispatch(
      visitationListActions.updateFilter({
        invitationTypes: undefined,
        supplier: undefined,
      }),
    );
  };

  const selected = !!query.invitationTypes || query.supplier !== undefined;

  return (
    <>
      <QcsToggleButton value="" selected={selected} onChange={handleOpenMenu}>
        {t('visitation.supplier')}
        <ArrowDropDownIcon />
      </QcsToggleButton>
      <StyledQcsPopover anchorEl={anchorEl} open={!!anchorEl} onClose={handleCloseMenu}>
        <GridFilterItemContainer>
          <FormContainer>
            <QcsFormControlLabel
              control={<QcsCheckbox checked={!!query.invitationTypes} onChange={handleChangeOneTimeOnly} />}
              label={t('visitation.oneTimeFilter')}
            />
            <QcsAutocompleteWithoutFormik
              options={optionsSupplier}
              loading={optionsSupplierState === FetchState.Loading}
              loadingError={optionsSupplierState === FetchState.Error}
              loadOptions={loadOptions}
              value={query.supplier}
              getOptionId={(option: ReferenceDto) => option.id!}
              getOptionName={(option: ReferenceDto) => getLangNameObj(i18n, option)}
              onChange={handleChange}
              disabled={!!query.invitationTypes}
            />
          </FormContainer>
        </GridFilterItemContainer>
        <GridFilterItemContainer>
          <QcsButton disabled={!selected} onClick={handleClear}>
            {t('common.clearFilter')}
          </QcsButton>
        </GridFilterItemContainer>
      </StyledQcsPopover>
    </>
  );
};
